<template>
    <div>
        <b-row class="mb-2">
            <b-col>
                <b-button @click="backToCalendar" class="btn btn-light mb-3"><i class="fa fa-chevron-left mr-2"></i> {{Core.Definition.getDefinition('Retour au calendrier')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'EventWeekTemplateContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/evenement/calendrier/modeles/nouveau-model')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/evenement/calendrier/modeles/nouveau-model'))
                }
            },
            backToCalendar() {
                this.$router.push(Core.Definition.getDefinition('/evenement/calendrier'))
            }
        }
    }
</script>
